import { Component, OnInit,EventEmitter, Input, Output } from '@angular/core';
import { paginationParams } from '@shared/config/table.config';
import { options, columnDefs } from './job-details.config';
import { JobDetailsService } from './job-details.service';
import { GlobalErrorService } from '@services/global-error.service';
import { HttpErrorResponse } from '@angular/common/http';
import { HiringManagerOpenpositionsService } from '../hiring-manager-openpositions/hiring-manager-openpositions.service';
import { ToasterService } from '@services/toaster.service';
import { Router } from '@angular/router';
import { dateFormat } from '@constants/dateFormat';
import { JobDetErrorMsg, PersonaType, JobStatusEnum, ApiStatus } from '@constants/global.enum';
import { SearchService } from '@services/search.service';
import { FileDownloadService } from '@services/file-download.service';
import { HiringRequestResponseData } from '@interfaces/hiring-manager.model';
import { jobDetails } from '@interfaces/job-details.model';
import { DataService } from '@services/data.service';
import { finalize, switchMap, tap } from 'rxjs/operators';
import { PositionData } from '@app/shared/interfaces/open-positions.model';
@Component({
  selector: 'app-job-details',
  templateUrl: './job-details.component.html',
  styleUrl: './job-details.component.scss',
})
export class JobDetailsComponent implements OnInit {
  displayData: jobDetails[] = [];
  totalCount: number = 0;
  filteredDropdown: jobDetails[] = [];
  paginationParams = paginationParams;
  options = options;
  rowData: jobDetails[] = [];
  columnDefs = columnDefs;
  fieldsVisibility: string = PersonaType.HireMgrJobDet;
  dateFormat = dateFormat;
  imageSrc: string = 'assets/img/no-data-found.png';
  errorMsg: string = JobDetErrorMsg.ErrorMessage;
  filterValue: string = '';
  urlDisplayLimit: number = 15;
  hiringRequest: HiringRequestResponseData | null = null;
  requeststatusoption: string = '';
  filePath: string = '';
  currentHiringRequestId: number = 0;
  currentJobTitle: string = '';
  projectName: string = '';
  primarySkills: string = '';
  hiringManagerName: string = '';
  isDataLoaded: boolean = false;
  showAlert: boolean = false;
  statusEnum = JobStatusEnum;
  // apiEnum: ApiStatus;

  @Input() openPositionData: PositionData | null = null;
  @Output() close = new EventEmitter<void>();

  constructor(
    public jobDetails: JobDetailsService,
    private globalError: GlobalErrorService,
    private fileDownloadService: FileDownloadService,
    public sharedservice: HiringManagerOpenpositionsService,
    private toasterService: ToasterService,
    private router: Router,
    private searchService: SearchService,
    private dataService: DataService
  ) {}

  ngOnInit() {
    if (this.openPositionData) {
      this.currentHiringRequestId = this.openPositionData.hiringRequestId;
      this.currentJobTitle = this.openPositionData.jobTitle;
      this.filePath = this.openPositionData.jobDescriptionPath;
      this.requeststatusoption = this.openPositionData.status;
      this.projectName = this.openPositionData.projectName;
      this.hiringManagerName = this.openPositionData.hiringManagerName;
      this.primarySkills = this.openPositionData.skillName.toString();
      this.loadJobDetails(this.currentHiringRequestId);
    }
  }

  private loadJobDetails(hiringId: number): void {
    this.jobDetails.getJobDetails(hiringId).subscribe({
      next: (res: any) => {
        if (Array.isArray(res.data?.candidates)) {
          this.rowData = res.data?.candidates;
        } else {
          this.rowData = [];
        }
        this.displayData = this.rowData;
        this.totalCount = this.displayData?.length || 0;
        this.isDataLoaded = true;
      },
      error: (error) => {
        this.isDataLoaded = true;
        this.globalError.logComponentError(error);
      }
    });
  }

  applyJobDetails(event: KeyboardEvent) {
    this.filterValue = this.searchService.getFilteredValue(event);
    this.displayData =
      this.rowData && this.rowData?.length
        ? this.searchService.getSearchedData(
            this.rowData,
            this.filterValue?.toLowerCase()
          )
        : [];
    this.totalCount = this.displayData?.length;
  }

  clearInput() {
    this.displayData = this.rowData;
    this.filterValue = '';
  }

  // ---- vendor-style inline filter panel (client-side over this job's candidates) ----
  showFilterPanel = false;
  jdFilterDraft = { location: '', experience: '' };
  jdActiveFilters = { location: '', experience: '' };

  get facetLocation(): string[] {
    const vals: string[] = [];
    (this.rowData || []).forEach((r: any) => {
      const loc = r?.location;
      const parts: any[] = Array.isArray(loc) ? loc : loc ? [loc] : [];
      parts.forEach((p) => {
        const v = (p ?? '').toString().trim();
        if (v) vals.push(v);
      });
    });
    return Array.from(new Set(vals)).sort((a, b) => a.localeCompare(b));
  }

  get facetExperience(): string[] {
    const vals = (this.rowData || [])
      .map((r: any) => r?.yearsOfExperience ?? r?.experience)
      .filter((v: any) => v !== null && v !== undefined && `${v}`.trim() !== '');
    return Array.from(new Set(vals)).sort((a: any, b: any) => a - b).map(String);
  }

  get activeFilterCount(): number {
    return Object.values(this.jdActiveFilters).filter((v) => !!v).length;
  }

  toggleFilterPanel(): void {
    this.showFilterPanel = !this.showFilterPanel;
    if (this.showFilterPanel) {
      this.jdFilterDraft = { ...this.jdActiveFilters };
    }
  }

  applyFilterPanel(): void {
    this.jdActiveFilters = { ...this.jdFilterDraft };
    this.showFilterPanel = false;
    this.applyLocalJdFilters();
  }

  resetFilterPanel(): void {
    this.jdFilterDraft = { location: '', experience: '' };
    this.jdActiveFilters = { ...this.jdFilterDraft };
    this.showFilterPanel = false;
    this.applyLocalJdFilters();
  }

  private applyLocalJdFilters(): void {
    const f = this.jdActiveFilters;
    let rows: any[] = [...(this.rowData || [])];
    if (f.location) {
      rows = rows.filter((r) => {
        const loc = r?.location;
        const parts: any[] = Array.isArray(loc) ? loc : loc ? [loc] : [];
        return parts.map((p) => (p ?? '').toString().trim()).includes(f.location);
      });
    }
    if (f.experience) {
      rows = rows.filter((r) => String(r?.yearsOfExperience ?? r?.experience) === f.experience);
    }
    this.displayData = rows;
    this.totalCount = this.displayData?.length || 0;
  }

  receiveData(data: string, candidateEmailId: string) {
    const candidate = this.displayData?.find(
      (item) => item.emailId === candidateEmailId
    );
    if (candidate) {
      candidate.status = data;
    }
  }

  valueSelect(event: string) {
    const userProfile = this.dataService.userProfile();
    const status = event;
    const updatedBy = userProfile.email;
    const hiringRequestId = this.currentHiringRequestId;

    this.jobDetails?.updateRequestStatus(status, updatedBy, hiringRequestId)
      .pipe(
        tap(() => {
          this.sharedservice.refreshOpenPositions();
        }),
        finalize(() => {
          this.toasterService.showSuccess(
            ApiStatus.UpdatedStatus,
            'Success'
          );
          this.router.navigate(['hiring-manager']);
        })
      )
      .subscribe({
        error: (error) => {
          this.toasterService.showError(
            error?.message || ApiStatus.FailedStatus,
            'Error'
          );
        }
      });
  }

  handleDataFromChild(data: jobDetails[]): void {
    this.displayData = data;
    this.totalCount = this.displayData?.length;
    this.filterValue = '';
  }

  job_Description(fileName: string) {
    const fullFileName = this.currentJobTitle + '_' + fileName + '.pdf';
    this.fileDownloadService.downloadFile(this.filePath, fullFileName);
  }

  downloadFile(filePath: string, fileName: string, fileType: string) {
    const fullFileName = fileType + '_' + fileName + '.pdf';
    this.fileDownloadService.downloadFile(filePath, fullFileName);
  }

  openUrlNewTab(urlToOpen: string | null | undefined) {
    if (!urlToOpen || typeof urlToOpen !== 'string') {
      this.globalError.logComponentError(
        new HttpErrorResponse({ error: 'Invalid URL' })
      );
      return;
    }
    const url = new URL(
      urlToOpen.startsWith('http') ? urlToOpen : 'http://' + urlToOpen
    );
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  confirmStatusChange() {
    this.showAlert = true;
  }

  updateStatus(status: JobStatusEnum) {
    this.requeststatusoption = status;
    this.showAlert = false;
    this.valueSelect(status);
  }

  navigateBack() {
    this.close.emit();
  }
  
  closeAlert() {
    this.showAlert = false;
  }
}
